<!--
 * @Version      : V1.0
 * @Date         : 2025-04-07 14:52:42
 * @fileName     : 客户档案详情
 * @Description  :
-->
<template>
  <el-drawer :title="title" v-loading="loading" :visible.sync="dialogDrawer" direction="rtl" :wrapperClosable="false"
    size="80%" :before-close="closeDrawer">
    <div class="details px-20 py-20 border-box">
      <descriptions v-if="!showDesc" :status="status" :row-data="rowData" :columns="columns" :span="2" :rules="rules"
        ref="descriptionsRef"></descriptions>
    </div>
    <div class="details-footer px-20 py-20 border-box" v-if="status !== 'view'">
      <el-button type="primary" @click="submit()">提交</el-button>
      <!-- <el-button type="primary" @click="temporarilyStore()">暂存</el-button> -->
      <el-button @click="clearForm()">清空</el-button>
    </div>
  </el-drawer>
</template>

<script>
import descriptions from '@/components/descriptions/index.vue'
import { queryCustomerProfileDetailsApi, queryCustomerProfileAddApi, queryCustomerProfileEditApi } from '@/api/basicInfo/index'
export default {
  components: {
    descriptions
  },
  props: {
    title: {
      type: String,
      default: '客户档案详情'
    },
    status: {
      type: String,
      default: 'view'
    }
  },
  data() {
    const validatePhone = (rule, value, callback) => {
      if (value && /^1[3456789]\d{9}$/.test(value)) {
        callback()
      } else {
        callback(new Error('请输入正确的手机号码'))
      }
    }
    return {
      dialogDrawer: false,
      loading: false,
      customerForm: {},
      cloneColumns: [],//复制一遍
      columns: [
        // { key: 'customerCode', label: '客户编号', span: 2, placeholder: '系统生成', input: 'input', type: 'text', disabled: true, defaultValue: '' },
        { key: 'customerName', label: '客户名称', span: 1, placeholder: '请输入客户名称', input: 'input', type: 'text', disabled: true, defaultValue: '' },
        { key: 'customerShortName', label: '客户简称', span: 1, placeholder: '请输入客户简称', input: 'input', type: 'text', disabled: true, defaultValue: '' },
        { key: 'customerContactPerson', label: '客户联系人', span: 1, placeholder: '请输入客户联系人', input: 'input', type: 'text', disabled: true, defaultValue: '' },
        { key: 'customerContactPhone', label: '联系电话', span: 1, placeholder: '请输入联系电话', input: 'input', type: 'text', disabled: true, defaultValue: '' },
        { key: 'customerAddress', label: '客户地址', span: 2, placeholder: '请输入客户地址', input: 'input', type: 'text', disabled: true, defaultValue: '' },
        { key: 'taxpayerName', label: '增值纳税人名称', span: 1, placeholder: '请输入增值纳税人名称', input: 'input', type: 'text', disabled: true, defaultValue: '' },
        { key: 'taxIdNumber', label: '纳税人识别号', span: 1, placeholder: '请输入纳税人识别号', input: 'input', type: 'text', disabled: true, defaultValue: '' },
        {
          key: 'invoiceTypeCode', label: '开票类型', span: 1, placeholder: '', input: 'radio', type: '', disabled: true, defaultValue: '', option: [
            { label: '专票', value: '1' },
            { label: '普票', value: '2' },
          ]
        },
        { key: 'invoiceAddress', label: '开票地址', span: 1, placeholder: '请输入开票地址', input: 'input', type: 'text', disabled: true, defaultValue: '' },
        { key: 'bankName', label: '开户银行', span: 1, placeholder: '请输入开户银行', input: 'input', type: 'text', disabled: true, defaultValue: '' },
        { key: 'bankAccount', label: '银行账号', span: 1, placeholder: '请输入银行账号', input: 'input', type: 'text', disabled: true, defaultValue: '' }
      ],
      rowData: {},
      showDesc: false,
      rules: {
        customerName: [{ required: true, message: '请输入客户名称', trigger: 'blur' }],
        customerShortName: [{ required: true, message: '请输入客户简称', trigger: 'blur' }],
        // customerAddress: [{ required: true, message: '请输入客户地址', trigger: 'blur' }],
        // taxpayerName: [{ required: true, message: '请输入增值纳税人名称', trigger: 'blur' }],
        // taxIdNumber: [{ required: true, message: '请输入增值纳税人名称', trigger: 'blur' }],
        // invoiceTypeCode: [{ required: true, message: '请选择开票类型', trigger: 'blur' }],
        // bankName: [{ required: true, message: '请输入开户银行', trigger: 'blur' }],
        // bankAccount: [{ required: true, message: '请输入银行账号', trigger: 'blur' }],
        // invoiceAddress: [{ required: true, message: '请输入开票地址', trigger: 'blur' }],
        // customerContactPhone: [
        //   { required: true, message: '请输入联系方式', trigger: 'blur' }
        // ],
      }
    }
  },
  mounted() {
    this.cloneColumns = JSON.parse(JSON.stringify(this.columns))
  },
  methods: {
    async openDrawer(row) {
      this.dialogDrawer = true;
      this.$nextTick(() => {
        switch (this.status) {
          case 'view':
            this.queryDetails({ id: row.id })
            break;
          case 'add':
            //新增把原有的数据设置默认值
            this.showDesc = true;
            for (let i = 0; i < this.columns.length; i++) {
              this.columns[i].disabled = false;
              this.columns[i].defaultValue = this.cloneColumns[i].defaultValue;
            }
            this.$nextTick(() => {
              this.showDesc = false;
            })
            break;
          case 'edit':
            this.queryDetails({ id: row.id })
            break;
          default:
            break;
        }
      })
    },
    closeDrawer() {
      this.dialogDrawer = false;
    },
    queryDetails(row) {
      this.loading = true;
      this.showDesc = true;
      queryCustomerProfileDetailsApi(row).then(res => {
        this.loading = false;
        this.showDesc = false;
        if (res.code == 200) {
          this.rowData = res.data;
          if (this.status == 'edit' || this.status == 'view') {
            for (let i = 0; i < this.columns.length; i++) {
              this.columns[i].disabled = this.status == 'view' ? true : false;
              this.columns[i].defaultValue = this.rowData[this.columns[i].key];
            }
          }
        }
      })
    },
    //提交
    submit(str = null) {
      this.$refs.descriptionsRef.submit().then(formData => {
        let params = {
          ...formData
        }
        this.loading = true;
        if (this.status == 'add') {
          queryCustomerProfileAddApi(params).then(res => {
            if (res.code == 200) {
              this.$message({
                message: res.msg,
                type: 'success'
              });
            } else {
              this.$message({
                message: res.msg,
                type: 'warning'
              });
            }
            this.loading = false;
            this.closeDrawer();
            this.queryData();
            //当为暂存状态 则不关闭弹出窗
            //  if(str == 'temporarilyStore'){
            //   this.clearForm()
            //  }else{
            //   this.closeDrawer();
            //   this.queryData();
            //  }

          })
        } else {
          queryCustomerProfileEditApi(params).then(res => {
            if (res.code == 200) {
              this.$message({
                message: res.msg,
                type: 'success'
              });
            } else {
              this.$message({
                message: res.msg,
                type: 'warning'
              });
            }
            this.loading = false;
            this.closeDrawer();
            this.queryData();
            //当为暂存状态 则不关闭弹出窗
            //  if(str == 'temporarilyStore'){
            //   this.clearForm()
            //  }else{
            //   this.closeDrawer();
            //   this.queryData();
            //  }

          })
        }

      })
    },
    temporarilyStore() { },
    //清空描述组件form
    clearForm() {
      this.$refs.descriptionsRef.resetForm()
    },
    //查询列表
    queryData() {
      this.$emit('initQueryData')
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-drawer__header {
  color: #000;
  font-size: 18px;
}
::v-deep .el-breadcrumb__separator{
  color: #000;
}

.details-footer {
  height: 50px;
  line-height: 50px;
  text-align: right;
}
</style>
